import { Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tooltip-icon',
  imports: [MatTooltip],
  templateUrl: './tooltip-icon.component.html',
  styleUrl: './tooltip-icon.component.scss'
})
export class TooltipIconComponent {
  @Input() text?: string;
  @Input() place: 'above' | 'below' = 'below';
  // Opt-in wider panel for long explanatory texts (Material caps tooltips at 200px by default).
  @Input() wide = false;
}
